import surveyEmoji3 from '@/assets/Emoji/survey/neutral.png';
import surveyEmoji2 from '@/assets/Emoji/survey/satisfied.png';
import surveyEmoji4 from '@/assets/Emoji/survey/unsatisfied.png';
import surveyEmoji1 from '@/assets/Emoji/survey/very_satisfied.png';
import surveyEmoji5 from '@/assets/Emoji/survey/very_unsatisfied.png';

/** Survey emoji set ordered worst → best (canonical Likert: index 0 = worst, last = best). Shared by questionnaire creation, survey answer and results rendering. */
const SURVEY_EMOJI_SOURCES = [surveyEmoji5, surveyEmoji4, surveyEmoji3, surveyEmoji2, surveyEmoji1];

/** Returns the survey emoji source by index (0 = worst, 4 = best). */
export const getEmojiSrc = (index: number): string => {
    return SURVEY_EMOJI_SOURCES[index] ?? '';
};

export { surveyEmoji1, surveyEmoji2, surveyEmoji3, surveyEmoji4, surveyEmoji5 };

/**
 * Returns the survey emoji source for a proportional index in results display.
 * Maps any option index to the 5 survey emojis proportionally.
 * Index 0 = worst, last index = best (matches the API which returns options in sortOrder ascending = worst first).
 */
export const getResultEmojiSrc = (index: number, total: number): string => {
    const mapped = Math.round((index / Math.max(total - 1, 1)) * (SURVEY_EMOJI_SOURCES.length - 1));
    return SURVEY_EMOJI_SOURCES[mapped] || surveyEmoji1;
};
